const BREVO_CONFIG = {
  id: '686b5c81bab956ec4c0bd9d0',
  scriptUrl: 'https://conversations-widget.brevo.com/brevo-conversations.js',
  setup: {
    customWidgetButton: '.foo',
    chatWidth: 400,
    chatHeight: 550,
    deferredLoading: true,
  },
  businessHours: {
    startHour: 9,
    endHour: 19,
    timezone: 'Europe/Stockholm',
  },
};

import * as brevo from './live-chat.web';

export { brevo, BREVO_CONFIG };
